import { Link } from "react-router-dom";
import { InfoWindow } from "@react-google-maps/api";

const BranchInfoWindow = ({
  branch,
  onClose,
  renderOrderStatus,
  updateSelectedBranch,
}) => {
  if (!branch) return null;

  const lat = Number(branch._position?.lat ?? branch.location.latitude);
  const lng = Number(branch._position?.lng ?? branch.location.longitude);

  return (
    <InfoWindow
      anchor={branch._marker}
      position={{ lat, lng }}
      onCloseClick={onClose}
      options={{
        disableAutoPan: true,
        pixelOffset: new window.google.maps.Size(0, -50),
      }}
    >
      <div className="p-3 shadow-sm rounded bg-body text-body">
        <div className="d-flex align-items-center mb-3">
          <img
            src={`${process.env.REACT_APP_API_PUBLIC_URL}${branch.logo}`}
            alt="Branch"
            className="rounded-circle me-3 border border-success"
            style={{ width: "48px", height: "48px", objectFit: "cover" }}
          />
          <div>
            <h6 className="mb-0">{branch.name}</h6>
            <small className="text-primary">{branch.phone}</small>
          </div>
        </div>

        {Array.isArray(branch.orders) && branch.orders.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-sm table-bordered text-body mb-3">
              <tbody>
                <tr className="text-center text-dark">
                  <th>Order Id</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>

                {branch.orders.map((order) => (
                  <tr key={order._id}>
                    <td>{order.orderId}</td>
                    <td>{renderOrderStatus(order.status)}</td>
                    <td>
                      <Link
                        to={`/orders/order-details/${order._id}`}
                        target="_blank"
                        className="badge bg-primary text-white"
                      >
                        DETAILS
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-5 mx-5">No Current Order</div>
        )}

        <div className="text-center">
          <button className="btn btn-danger btn-sm" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </InfoWindow>
  );
};

export default BranchInfoWindow;
